var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loadingVerificationData),expression:"loadingVerificationData"}],attrs:{"element-loading-spinner":"qc-spinner","loading":_vm.loadingVerificationData}},[_c('canvas',{staticClass:"canvas-container",attrs:{"id":"verificationsGraph"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }